import * as Actions from '../actions';

const initialState = {
    permissionFullList: [],
    authRoleList:       [],
}

const permissionReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_PERMISSIONS_FULL_LIST):
        {
            return {
                ...state,
                permissionFullList: action.payload,
            }
        }

        case (Actions.GET_AUTH_ROLE_LIST):
        {
            return {
                ...state,
                authRoleList: action.payload
            }
        }

        case (Actions.UPDATE_ROLE_PERMISSION):
        {
            const { permission_id, role_id, status } = action.payload;
            
            return {
                ...state,
                permissionFullList: state.permissionFullList.map((permission_info) => {
                    if(permission_info.permission_id === permission_id) {
                        return {
                            ...permission_info,
                            ActiveRoleList: permission_info.ActiveRoleList.map((permission_role_info) => {
                                if(permission_role_info.role_id === role_id) {
                                    return {
                                        ...permission_role_info,
                                        Active: status,
                                    };
                                } else {
                                    return permission_role_info;
                                }
                            })
                        }
                    } else {
                        return permission_info
                    }
                })
            }
        }
        default:
        {
            return state;
        }
    }
}

export default permissionReducer;


// WEBPACK FOOTER //
// src/main/content/permission/store/reducers/permission.reducer.js